/**
 * FPS / ping overlay — a small monospace readout under the gold counter,
 * shown only when the "Show FPS & ping" setting is on (off by default).
 *
 * The render loop in main.ts samples a rolling fps over a ~0.5s window and a
 * latency probe round-trips a ping every 2s; both are pushed in via update().
 * Visibility is driven by debug-overlay-settings so the settings checkbox can
 * flip it instantly without main.ts having to wire a callback.
 */
import { getShowFps, onShowFpsChange } from "./debug-overlay-settings";

export interface FpsOverlay {
  /** Push the latest sampled fps + round-trip ping (ms, or null if unknown). */
  update(fps: number, pingMs: number | null): void;
}

export function createFpsOverlay(): FpsOverlay {
  const el = document.createElement("div");
  el.id = "fps-overlay";
  el.style.display = getShowFps() ? "block" : "none";
  document.body.appendChild(el);

  onShowFpsChange((on) => {
    el.style.display = on ? "block" : "none";
  });

  return {
    update(fps, pingMs) {
      if (!getShowFps()) return; // hidden — skip the DOM write entirely
      const ping = pingMs === null ? "—" : `${Math.round(pingMs)}`;
      el.textContent = `${Math.round(fps)} fps · ${ping} ms`;
    },
  };
}
